export interface PersonInfo {
  firstName: string;
  lastName: string;
  motherLastName?: string;
  dateOfBirth?: string;
  gender?: string;
  nationality?: string;
  maritalStatus?: string;
}

export interface ValidateRutRequest {
  rut: string;
}

export interface ValidateRutResponse {
  isValid: boolean;
  formattedRut?: string;
  personInfo?: PersonInfo;
  warning?: 'foreign_rut' | 'company_rut' | 'test_rut';
  error?: string;
}

export interface AutoredVehicleInfo {
  brandId?: number;
  brandName?: string;
  modelId?: number;
  modelName?: string;
  versionName?: string;
  year?: number;
  color?: string;
  licensePlate?: string;
  fuelType?: string;
  fuelTypeName?: string;
  transmission?: string;
  transmissionName?: string;
  vehicleType?: string;
  vin?: string;
  engineNumber?: string;
  cylinderCapacity?: number;
  traction?: string;
  tractionName?: string;
  modelImage?: string;
  modelUrl?: string;
}

export interface ValidateLicensePlateRequest {
  licensePlate: string;
}

export interface ValidateLicensePlateResponse {
  isValid: boolean;
  formattedPlate?: string;
  vehicleInfo?: AutoredVehicleInfo;
  error?: string;
}

export interface RequestQuotesRequest {
  rut: string;
  licensePlate: string;
  email: string;
  phone: string;
  personInfo: {
    firstName: string;
    lastName: string;
    motherLastName?: string;
  };
  vehicleInfo: AutoredVehicleInfo;
  businessUnitId?: number;
}

export interface RequestQuotesResponse {
  clientId?: number;
  leadId?: number;
  companiesRequested?: string[];
  errors?: string[];
  error?: string;
}

export interface CompanyQuoteStatus {
  name: string;
  displayName: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  quotesCount?: number;
  error?: string;
}

export interface QuoteStatusResponse {
  status: 'pending' | 'partial' | 'completed';
  companies: CompanyQuoteStatus[];
  totalQuotes: number;
}

export interface InsuranceCompanyOption {
  name: string;
  displayName: string;
  discount?: number | null;
}

/** Basic quote fields returned by GET /quotes/:leadId (insurance quote form flow) */
export interface InsuranceQuoteListItem {
  id: number;
  insuranceCompany: string;
  planName: string;
  deductible: number;
  premiumCLP: number | null;
  premiumUF: number | null;
  paymentMethod: string;
  paymentFrequency: string;
}

export interface InsuranceQuoteFormData {
  rut: string;
  formattedRut: string;
  personInfo: PersonInfo | null;
  licensePlate: string;
  formattedPlate: string;
  vehicleInfo: AutoredVehicleInfo | null;
  email: string;
  phone: string;
}

export const initialFormData: InsuranceQuoteFormData = {
  rut: '',
  formattedRut: '',
  personInfo: null,
  licensePlate: '',
  formattedPlate: '',
  vehicleInfo: null,
  email: '',
  phone: '',
};
